import AIJob from 'models/AIJob';

export enum SummarizationStage {
  ProcessingFiles = 'Processing files',
  GeneratingSummary = 'Generating summary',
  FinishingUp = 'Finishing up',
}

export const SUMMARIZATION_LOADING_STAGES = Object.values(SummarizationStage);

export function summarizationLoadingStage({
  summaryJob,
  onFinalStage,
}: {
  summaryJob: AIJob | null;
  onFinalStage: boolean;
}): number {
  if (!summaryJob) return 0;
  if (summaryJob.isCompleted) return SUMMARIZATION_LOADING_STAGES.length + 1;

  let stage: SummarizationStage;
  if (summaryJob.isAwaiting || summaryJob.isRunning) {
    stage = onFinalStage ? SummarizationStage.FinishingUp : SummarizationStage.GeneratingSummary;
  } else if (summaryJob.isPending) {
    stage = SummarizationStage.ProcessingFiles;
  } else {
    return 0;
  }

  return SUMMARIZATION_LOADING_STAGES.indexOf(stage) + 1;
}

// With no attribute extraction job, nothing will populate the patient later, so show it as is.
export function revealPatientImmediately(
  attributeExtractionJob: AIJob | null,
  lastSeenAt: Date | null | undefined
): boolean {
  if (!attributeExtractionJob) return true;

  return (
    attributeExtractionJob.isCompleted &&
    !!lastSeenAt &&
    !!attributeExtractionJob.updatedAt &&
    lastSeenAt > new Date(attributeExtractionJob.updatedAt)
  );
}
